/* src/app/core/modules/shared/components/tip-card/tip-card.component.scss */
/*# sourceMappingURL=/avvera/dev/tip-card.component.css.map */
